import { FC, useMemo, ReactNode, useCallback } from 'react'
import ButtonRow from 'components/atoms/buttons/ButtonRow'
import { ButtonProps } from 'components/features/pfm/Button/Button'
import { ConfirmModalLayout } from 'components/features/pfm/ConfirmModalLayout/ConfirmModalLayout'

export type ConfirmModalProps = {
  confirmButtonText: string
  confirmButtonDisabled?: boolean
  children?: ReactNode
  onCancel?: () => void
  onConfirm: () => void
}

export const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { children, onCancel, onConfirm, confirmButtonText, confirmButtonDisabled } = props
  const theme = confirmButtonText.toLowerCase() === 'delete' ? 'danger' : 'blue'

  const handleCancel = useCallback(() => {
    onCancel && onCancel()
  }, [onCancel])

  const buttonsChild = useMemo(() => {
    const buttons = [
      { text: confirmButtonText, theme, onClick: onConfirm, qaMarker: 'confirm-button', disabled: confirmButtonDisabled },
    ] as ButtonProps[]
    if (onCancel) {
      buttons.push({ text: 'Cancel', style: 'hollow', onClick: onCancel, qaMarker: 'cancel-button', disabled: false })
    }
    return (
      <ButtonRow
        size='tiny'
        buttons={ buttons }
      />
    )
  }, [confirmButtonText, onCancel, onConfirm, theme, confirmButtonDisabled])

  return (
    <ConfirmModalLayout
      onCancel={ handleCancel }
      buttons={ buttonsChild }
    >
      { children }
    </ConfirmModalLayout>
  )
}

export default ConfirmModal
